import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as RateCodeAction from './../../../../actions/rateCodeAction';
import RateCode from './RateCode';

const mapStateToProps = state => {
    return {
        rateCodeState: state.rateCodeReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRateCodeList: (filters) => dispatch(RateCodeAction.getRateCodeList(filters)),
        lockRateCode: (rateCode, filters) => dispatch(RateCodeAction.lockRateCode(rateCode, filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RateCode));